<template>
  <div class="content-panel">
    <div class="filter-inline-panel cle">
      <el-form :inline="true" :model="filterForm" class="filter-panel">
        <!-- <el-form-item label="菜单名称：">
				<el-input v-model="filterForm.realName" placeholder="请输入用户名称"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="list_f()">查询</el-button>
				<el-button type="" @click="filterForm.realName =''">重置</el-button>
			</el-form-item> -->
      </el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" @click="openDialog('yungong')" v-if="hasBtn('btn_add')">新建</el-button>
      </div>
    </div>
    <div>
      <el-table :data="listData" size="mini" row-key="id" border :tree-props="{children: 'Menu', hasChildren: 'hasChildren'}">
        <el-table-column prop="name" width="200" label="菜单名称"></el-table-column>
        <el-table-column prop="value" align="center" label="编号"></el-table-column>
        <el-table-column prop="sort" align="center" sortable label="排序"></el-table-column>
        <el-table-column prop="icon_url" align="center" label="图标">
          <template slot-scope="scope">
            <i :class="scope.row.icon_url" class="iconfont"></i>
          </template>
        </el-table-column>
        <el-table-column prop="link" align="center" label="链接"></el-table-column>
        <el-table-column prop="menu_flag" align="center" label="启动状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.menu_flag" :active-value="'1'" :inactive-value="'0'" @change="changeStatus(scope.row.menu_flag,scope.row.id)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="bianjDelete( scope.row)">编辑</el-button>
            <el-button size="mini" type="info" @click="listDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <p><br></p>
      <el-table :data="listData_" size="mini" row-key="id" border :tree-props="{children: 'Menu', hasChildren: 'hasChildren'}">
        <el-table-column prop="name" label="数据名称"></el-table-column>
        <el-table-column prop="value" align="center" label="编号"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="bianjDelete( scope.row)">编辑</el-button>
            <el-button size="mini" type="info" @click="listDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="提示" :visible.sync="deleteDialog" width="30%">
      <div>确认删除吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteTreeItem()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="yungong.id?'编辑菜单':'新建菜单'" custom-class="add-data-base" :visible.sync="addxuangDialog" width="900px">
      <el-form label-width="100px" ref="yungong" v-if="addxuangDialog" :rules="yungongRules" :model="yungong">
        <div class="pingweibuyao">
          <input type="text" name="name">
          <input type="password" name="password">
        </div>
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
	        <el-form-item label="数据类型：" prop="data_type">
	        	<el-select v-model="yungong.data_type" placeholder="请选择状态" class="w100">
	                <el-option label="菜单" value="1"></el-option>
	                <el-option label="数据" value="2"></el-option>
	            </el-select>
	        </el-form-item>
	    </el-col>
          <el-col :span="12" v-if="yungong.data_type==1">
	        <el-form-item label="选择分类：" prop="menu_type">
	          <el-radio-group v-model="yungong.menu_type">
	            <el-radio :label="1">目录</el-radio>
	            <el-radio :label="2">菜单</el-radio>
	            <el-radio :label="3">按钮</el-radio>
	          </el-radio-group>
	        </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称：" prop="name">
              <el-input v-model="yungong.name" placeholder="请输入菜单名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="yungong.data_type==2">
            <el-form-item label="上级菜单：">
              <el-cascader style="width: 100%" v-model="yungong.parent_id" :options="listData_data" :props="treeProps"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="yungong.data_type==1">
            <el-form-item label="上级菜单：">
              <el-cascader style="width: 100%" v-model="yungong.parent_id" :options="attrTreeData" :props="treeProps"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="yungong.data_type==1">
            <el-form-item label="链接地址：" prop="link">
              <el-input v-model="yungong.link" placeholder="请输入链接地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应用编码：" prop="value">
              <el-input v-model="yungong.value" placeholder="请输入应用编码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="yungong.data_type==1">
            <el-form-item label="排序：" prop="sort">
              <el-input v-model="yungong.sort" placeholder="请输入排序"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="yungong.data_type==1">
            <el-form-item label="启动状态：" prop="menu_flag">
              <el-select v-model="yungong.menu_flag" placeholder="请选择状态" class="w100">
                <el-option label="启用禁用" value="0"></el-option>
                <el-option label="启动" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="yungong.data_type==1">
            <el-form-item label="图标：" prop="icon_url">
              <el-input v-model="yungong.icon_url" placeholder="请输入图标"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-bottom-btn">
        <el-button @click="addxuangDialog=false">取 消</el-button>
        <el-button type="primary" @click="yungongaddNew('yungong')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	data() {
		return {
			attrTreeData: [],
			treeProps: {
				children: 'Menu',
				label: 'name',
				value: 'id',
				checkStrictly: true

			},
			filterForm: {
				realName: '',
			},
			listData: [],
			listData_: [],
			listData_data: [],
			permId: '',
			deleteDialog: false,
			addxuangDialog: false,
			yungongRules: {
				data_type: [{
					required: true,
					message: '请选择数据类型',
					trigger: 'blur'
				}, ],
				name: [{
					required: true,
					message: '请输入菜单名称',
					trigger: 'blur'
				}, ],
				menu_type: [{
					required: true,
					message: '请选择分类',
					trigger: 'change'
				}, ],
			},
			yungong: {

			},
		}
	},
	// 初始事件
	mounted: function () {
		// this.init();
		// this.get_menu_children();
	},
	// 事件
	methods: {
		get_menu_children: function () {
			var this_ = this;
			var url = "/admin_base_api/get_menu_children"
			var datas = {}
			this_.$post(url, datas).then((res) => {
				this_.attrTreeData = res.list;
				this_.listData_data = res.data;
			})
		},
		init: function () {
			var this_ = this;
			var url = "admin_base_api/menu_list"
			var datas = {}
			this_.$post(url, datas).then((res) => {
				this_.listData = res.list;
				this_.listData_ = res.data;
			})
		},
		listDelete: function (index,data) {
			this.permId = data.id;
			this.deleteDialog = true;
		},
		bianjDelete: function (data) {
			this.yungong = data;
			this.yungong.menu_type = Number(data.menu_type);
			this.addxuangDialog = true;
		},
		deleteTreeItem: function () {
			var this_ = this;
			var url = "/admin_base_api/menu_delete"
			var datas = {
				id: this_.permId
			}
			this_.$post(url, datas).then((res) => {
				this.$message.success('删除成功');
				this.deleteDialog = false
				this.init();
			})
		},
		openDialog: function (formName) {
			this.addxuangDialog = true;
			this.yungong = {
				data_type:'1',
				menu_type: '',
				name: '',
				parent_id: 0,
				value: '',
				link: '',
				sort: '',
				menu_flag: '1',
				icon_url: '',
			}
		},
		changeStatus: function (menu_flag, id) {
			var url = "/admin_base_api/menu_save";
			var datas = {
				id: id,
				menu_flag: menu_flag,
			}
			this.$post(url, datas).then((res) => {
				this.$message.success('修改成功');
				this.addxuangDialog = false;
			});
		},
		yungongaddNew: function (formName) {
			var url = "/admin_base_api/menu_save";
			var this_ = this;
			this.$refs[formName].validate((valid) => {
				if (valid) {
					var menu_type=1;
					var parent_id = 0;
					if (typeof this_.yungong.parent_id == 'string') {
						parent_id = this_.yungong.parent_id;
						menu_type=1;
					} else if (this_.yungong.parent_id.length > 1) {
						menu_type=this_.yungong.parent_id.length+1;
						parent_id = this_.yungong.parent_id.pop()
					} else if (this_.yungong.parent_id.length === 1) {
						parent_id = this_.yungong.parent_id.toString()
						menu_type=2
					} else if (this_.yungong.parent_id.length === 0) {
						parent_id = 0
						menu_type=1
					}
					var url = "/admin_base_api/menu_save";
					var datas = {
						data_type: this.yungong.data_type,
						name: this.yungong.name,
						value: this.yungong.value || '',
						parent_id:parent_id,
					}
					if (datas.data_type==1) {
						datas['link']=this.yungong.link;
						datas['sort']=this.yungong.sort;
						datas['icon_url']=this.yungong.icon_url;
						datas['menu_type']=this.yungong.menu_type;
					}else{
						datas['menu_type']=menu_type;
					}
					var tishi = '添加成功';
					if (this_.yungong.id) {
						datas['menu_type']=this.yungong.menu_type;
						datas['id'] = this.yungong.id;
						tishi = '修改成功';
					}
					this.$post(url, datas).then((res) => {
						this.$message.success(tishi);
						this.addxuangDialog = false;
						this.init();
					});
				} else {
					return false;
				}
			});
		},
		goPage: function () {},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 18px;
}
.pingweibuyao {
	position: absolute;
	left: -142px;
	top: 0;
	width: 1px;
	opacity: 0;
}
.content-panel {
	min-height: calc(100vh - 252px);
	background: #ffffff;
	padding: 25px 30px;
}
.content-panel .page-pagination {
	padding: 25px 10px;
	text-align: right;
}
.content-panel .page-pagination .filter-inline-panel {
	margin-bottom: 25px;
}
.content-panel .page-pagination .filter-inline-panel .add-data-base .el-select {
	width: 100%;
}
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.list-opinion {
	display: inline-block;
	width: 18%;
	text-align: right;
	vertical-align: top;
}
.dialog-bottom-btn {
	text-align: center;
}
.list-btn-group {
	margin: 0;
}
.list-btn-group a {
	color: #1890FF;
	cursor: pointer;
	margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/menu.vue